var f = Object.defineProperty;
var g = (o, n, t) => n in o ? f(o, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[n] = t;
var c = (o, n, t) => g(o, typeof n != "symbol" ? n + "" : n, t);
import { HttpClient as h, httpClient as i } from "../../httpClient.js";
class d extends h {
  constructor() {
    super(...arguments);
    c(this, "endpoint", "/chats");
  }
  async getAll(t) {
    const e = new URLSearchParams();
    t != null && t.limit && e.append("limit", t.limit.toString()), (t == null ? void 0 : t.offset) !== void 0 && e.append("offset", t.offset.toString());
    const s = e.toString();
    return i.get(
      s ? `${this.endpoint}?${s}` : this.endpoint
    );
  }
  async getOne(t) {
    return i.get(`${this.endpoint}/${t}`);
  }
  async create(t) {
    return i.post(this.endpoint, t);
  }
  async createMessage(t, e) {
    return i.post(`${this.endpoint}/${t}/messages`, e);
  }
  async getStudents() {
    return i.get("/students");
  }
  async getTeachers() {
    return i.get("/teachers");
  }
  async getUsers(t) {
    const e = new URLSearchParams();
    t != null && t.searchTerm && e.append("searchTerm", t.searchTerm), t != null && t.limit && e.append("limit", t.limit.toString()), (t == null ? void 0 : t.offset) !== void 0 && e.append("offset", t.offset.toString());
    const s = e.toString();
    return i.get(s ? `/chat-users?${s}` : "/chat-users");
  }
}
const l = new d();
export {
  l as default
};
